import { render, staticRenderFns } from "./FiltersTableAtenciones.vue?vue&type=template&id=dab651d2"
import script from "./FiltersTableAtenciones.vue?vue&type=script&lang=js"
export * from "./FiltersTableAtenciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports